import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";
import account from "reducers/account";
import accounts from "reducers/accounts";
import firebase from "reducers/firebase";
import integrationTypes from "reducers/integrationTypes";
import currentModal from "reducers/currentModal";
import view from "reducers/view";
import user from "reducers/user";
import chromeExtension from "reducers/chromeExtension";
import billing from "reducers/billing";
import system from "reducers/system";
import navigation from "reducers/navigation";
import spoofing from "reducers/spoofing";

const state = combineReducers({
  account,
  accounts,
  firebase,
  routing: routerReducer,
  currentModal,
  user,
  view,
  chromeExtension,
  integrationTypes,
  billing,
  system,
  navigation,
  spoofing
});

export default state;
